import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  DOCUMENT,
  ChangeDetectionStrategy,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LoaderService } from "./helpers/services/loader.service";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import { GaService } from "./helpers/services/ga.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LocalizationService } from "./helpers/services/localization.service";
import { environment } from "src/environments/environment";
import { CoreService } from "./helpers/services/core.service";
import { AuthService } from "./helpers/services/auth.service";
import { Location } from "@angular/common";
import { LanguageService } from "./helpers/services/language.service";

declare global {
  interface Window {
    //gtag: (...args: any[]) => void
    dataLayer: Record<string, any>;
  }
}

@Component({
  selector: "loyaltic-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  title = "loyaltic";
  public loading = false;
  currentLang = "se";
  showLocalizationPopup = false;
  showSettingIcon = false;
  cultureParam: any;
  isLiveUrl = false;
  date = new Date();
  culture: any;
  // isComingSoon = true;
  // lockview = true;
  // make isComingSoon & lockview  true while using coming-soon logic
  isComingSoon = false;
  lockview = false;

  cookieScriptUrl: any;

  @ViewChild("localizationPopup") localizationPopupRef: any;
  public modalRef!: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: "lyltc win modal-md modal-dialog-left",
  };

  domainInfo = [
    { culture: "sv-SE", domain: "", Brand: "elx" },
    { culture: "da-DK", domain: "dk", Brand: "elx" },
    { culture: "da-DK", domain: "aeg-dk", Brand: "aeg" },
    { culture: "nb-NO", domain: "no", Brand: "elx" },
    { culture: "nb-NO", domain: "aeg-no", Brand: "aeg" },
  ];

  liveUrls = [
    "sverige.electroluxcashback.se",
    "danmark.electroluxcashback.dk",
    "danmark.aegcashback.dk",
    "norge.electroluxcashback.no",
    "norge.aegcashback.no",
  ];

  constructor(
    public translate: TranslateService,
    private loader: LoaderService,
    private router: Router,
    private modalService: BsModalService,
    private localizationService: LocalizationService,
    public gaService: GaService,
    private activatedRoute: ActivatedRoute,
    private coreService: CoreService,
    private authService: AuthService,
    private location: Location,
    private languageService: LanguageService,
    @Inject(DOCUMENT) private doc: any,
  ) {
    this.checkComingSoon();
    translate.addLangs(["da-DK", "fi-FI", "sv-SE", "nb-NO", "is-IS", "en-US"]);

    let language = "sv-SE";
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;

    //console.log('pathname', pathname)

    const brand = window.location.href.includes("aeg") ? "aeg" : "elx";
    console.log("AppComponent - brand", brand);
    if (
      window.location.href.includes("se") ||
      window.location.href.includes("sverige.electroluxcashback.se") ||
      window.location.href.includes("swewagelx26.azurewebsites.net")
    ) {
      language = "sv-SE";
      this.currentLang = "se";
      localStorage.setItem("brand", "");
    } else if (
      (window.location.href.includes("dk") &&
        window.location.href.includes("danmark.electroluxcashback.dk") &&
        brand == "elx") ||
      window.location.href.includes("swewagelx26-dk.azurewebsites.net")
    ) {
      language = "da-DK";
      this.currentLang = "dk";
      localStorage.setItem("brand", "elx");
    } else if (
      (window.location.href.includes("dk") &&
        window.location.href.includes("danmark.aegcashback.dk") &&
        brand == "aeg") ||
      window.location.href.includes("swewagelx26-aeg-dk.azurewebsites.net")
    ) {
      language = "da-DK";
      this.currentLang = "dk";
      localStorage.setItem("brand", "aeg");
    } else if (
      (window.location.href.includes("no") &&
        window.location.href.includes("norge.electroluxcashback.no") &&
        brand == "elx") ||
      window.location.href.includes("swewagelx26-no.azurewebsites.net")
    ) {
      language = "nb-NO";
      this.currentLang = "no";
      localStorage.setItem("brand", "elx");
    } else if (
      (window.location.href.includes("no") &&
        window.location.href.includes("norge.aegcashback.no") &&
        brand == "aeg") ||
      window.location.href.includes("swewagelx26-aeg-no.azurewebsites.net")
    ) {
      language = "nb-NO";
      this.currentLang = "no";
      localStorage.setItem("brand", "aeg");
    } else if (pathname.startsWith("/se")) {
      language = "sv-SE";
      this.currentLang = "se";
    } else if (pathname.startsWith("/dk") || pathname.startsWith("/aeg-dk")) {
      language = "da-DK";
      this.currentLang = "dk";
      localStorage.setItem("brand", "elx");
      if (pathname.startsWith("/aeg-dk")) {
        localStorage.setItem("brand", "aeg");
      }
    } else if (
      pathname.startsWith("/dk") ||
      pathname.startsWith("/aeg-dk") ||
      pathname.startsWith("/elx-no")
    ) {
      language = "da-DK";
      this.currentLang = "dk";
      localStorage.setItem("brand", "elx");
      if (pathname.startsWith("/aeg-dk")) {
        localStorage.setItem("brand", "aeg");
      }
    } else if (
      pathname.startsWith("/no") ||
      pathname.startsWith("/aeg-no") ||
      pathname.startsWith("/elx-dk")
    ) {
      language = "nb-NO";
      this.currentLang = "no";
      localStorage.setItem("brand", "elx");
      if (pathname.startsWith("/aeg-no")) {
        localStorage.setItem("brand", "aeg");
      }
    } else {
      language = "sv-SE";
      this.currentLang = "se";
      localStorage.setItem("brand", "");
    }
    var currLanguageVal = language;
    localStorage.setItem("currLanguage", language);
    translate.setDefaultLang(language);

    // if (window.location.href.includes('cordless.electroluxcashback.se') || window.location.href.includes('hobs.electroluxcashback.se') || window.location.href.includes('sweaegpf23electro-se.azurewebsites.net')) {
    //   translate.setDefaultLang('sv-SE');
    //   localStorage.setItem('currLanguage', 'sv-SE');
    // } else if(window.location.href.includes('cordless.electroluxcashback.dk')){
    //   currLanguageVal = 'da-DK';
    //   translate.setDefaultLang('da-DK');
    //   localStorage.setItem('currLanguage', 'da-DK');
    // } else if(window.location.href.includes('cordless.electroluxcashback.fi') || window.location.href.includes('hobs.electroluxcashback.fi') || window.location.href.includes('sweaegpf23electro-fi.azurewebsites.net')){
    //   currLanguageVal = 'fi-FI';
    //   translate.setDefaultLang('fi-FI');
    //   localStorage.setItem('currLanguage', 'fi-FI');
    // } else if(window.location.href.includes('cordless.electroluxcashback.no')) {
    //   currLanguageVal = 'nb-NO';
    //   translate.setDefaultLang('nb-NO');
    //   localStorage.setItem('currLanguage', 'nb-NO');
    // }

    this.translate.get("cookie-script").subscribe((translatedString) => {
      this.cookieScriptUrl = translatedString;
      this.loadCookieScript(this.cookieScriptUrl);
      this.setGTagManager(currLanguageVal);
      //this.cookieScript(currLanguageVal, this.cookieScriptUrl);
      //console.log(this.gaScript1);
    });
  }

  ngOnInit() {
    const lang = this.translate.getDefaultLang(); // or this.translate.currentLang
    // Set <html lang="...">
    document.documentElement.lang = lang;

    this.addGaScript();
    this.handleFavicon();
    //var currLanguageVal = 'ooppp';
    //this.loadScript()

    this.loader.getInputChangeLoaderEmitter().subscribe((res: any) => {
      this.loading = res;
    });

    this.router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: "virtualPageview",
          virtualPage: item.url,
        };

        window && window.dataLayer && window.dataLayer.push(gtmTag);
      }
    });
  }

  // for cookie script
  loadCookieScript(cookieScript: any) {
    let dynamicScript = document.createElement("script");
    dynamicScript.type = "text/javascript";
    dynamicScript.charset = "UTF-8";
    var doc = new DOMParser().parseFromString(cookieScript, "text/html");
    let src = doc.scripts[0].getAttribute("src");
    dynamicScript.src = src!;
    document.body.appendChild(dynamicScript);
  }

  addGaScript() {
    this.translate.get("ga-script-id").subscribe(
      (translatedString: string) => {
        let dynamicScript = document.createElement("script");
        dynamicScript.async = true;
        dynamicScript.src =
          "https://www.googletagmanager.com/gtag/js?id=" + translatedString;
        document.head.appendChild(dynamicScript);

        let tagScript = document.createElement("script");
        tagScript.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
  
      gtag('config', '${translatedString}');`;
        document.head.appendChild(tagScript);
      },
      (error) => {
        console.log(error);
      },
    );
  }

  // for gtm script
  private setGTagManager(currentLang: string) {
    const gtm = this.doc.createElement("script");
    gtm.type = "text/javascript";
    gtm.innerHTML =
      `window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'pageType': 'CashbackCampaignPage', 'pageLanguage':'` +
      currentLang +
      `', 'universalPropertyId':'UA-173935033-5', 'GA4PropertyId':'G-R2KGZXSE3T'});
    
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5V38XH');
    
    `;
    const head = this.doc.getElementsByTagName("head")[0];
    head.appendChild(gtm);
  }

  changeLanguage(key: string) {
    this.translate.setDefaultLang(key);
    this.translate.getTranslation(key).subscribe((translation) => {
      this.translate.setTranslation(key, translation, true);
      this.translate.use(key);
    });
  }

  showLocalizations() {
    this.showLocalizationPopup = true;
    this.modalRef = this.modalService.show(
      this.localizationPopupRef,
      this.popupConfig,
    );
  }

  async checkComingSoon() {
    const hostname = window.location.hostname;
    console.log("hostname", hostname);
    // Api call for golive
    // let response = await this.liveconfig();
    await this.coreService.getLiveConfig().then((response: any) => {
      console.log("response", response);
      const goLiveDateString = response.result.liveDate;
      const goLiveDate = new Date(goLiveDateString);
      console.log("goLiveDate", goLiveDate);
      // response.result.liveUrls.forEach((element: string) => {
      //   if (hostname.toLowerCase().indexOf(element) != -1) {
      //     this.isLiveUrl = true;
      //   }
      // });
      this.isLiveUrl = this.liveUrls.indexOf(hostname) > -1;
      console.log("this.isLiveUrl", this.isLiveUrl);
      //if (goLiveDate > this.date && this.isLiveUrl && !window.location.href.includes('localhost')) {
      if (goLiveDate > this.date && this.isLiveUrl) {
        console.log("show comin soon page");
        this.lockview = false;
        this.isComingSoon = true;
        // this.router.navigate(['coming-soon'])
      } else {
        this.lockview = false;
        this.isComingSoon = false;
      }
    });
  }

  // Method to remove/replace favicon
  handleFavicon(): void {
    const domain = window.location.hostname;
    const pathname = window.location.pathname;
    const brand = localStorage.getItem("brand");

    let link: HTMLLinkElement | null =
      document.querySelector("link[rel*='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    if (
      environment.dkAEGDomains.includes(domain) ||
      environment.noAEGDomains.includes(domain)
    ) {
      // AEG favicon
      link.href = "/favicon-aeg.ico";
    } else if (
      environment.dkDomains.includes(domain) ||
      pathname.startsWith("/dk") ||
      environment.noDomains.includes(domain) ||
      pathname.startsWith("/no")
    ) {
      // ELX favicon
      link.href = "/favicon.ico";
    }

    // if (
    //   environment.dkDomains.includes(domain) ||
    //   pathname.startsWith("/dk") ||
    //   environment.noDomains.includes(domain) ||
    //   pathname.startsWith("/no")
    // ) {
    //   let link: HTMLLinkElement | null =
    //     document.querySelector("link[rel*='icon']");
    //   if (!link) {
    //     link = document.createElement("link");
    //     link.rel = "icon";
    //     document.head.appendChild(link);
    //   }
    //   // AEG favicon
    //   //link.href = "favicon-aeg.ico";
    // }
  }
}
